module.exports = require('./helpers/bundle-url').getBundleURL('9vyx9') + "logo.c51670a8.svg";